const omit = (paths) => {
    return (object) => {
        // 总是返回新对象
        const result = Object.assign({}, object);
        paths.forEach(path => {
            delete result[path];
        });
        return result;
    };
};
export default omit;
